import IconButton from '@mui/material/IconButton';
import { useAppDispatch, useAppSelector } from 'app/store/hooks';
import { selectFuseCurrentSettings, setDefaultSettings } from '@fuse/core/FuseSettings/fuseSettingsSlice';
import _ from '@lodash';
import useThemeMediaQuery from '@fuse/hooks/useThemeMediaQuery';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { FuseSettingsConfigType } from '@fuse/core/FuseSettings/FuseSettings';
import { navbarToggle, navbarToggleMobile, selectFuseNavbar } from './navbarSlice';

type NavbarToggleButtonProps = {
	className?: string;
	children?: React.ReactNode;
};

/**
 * The navbar toggle button. You can change color of nav toggle button here 
 */
function NavbarToggleButton(props: NavbarToggleButtonProps) {
	const { className = '' } = props;

	const dispatch = useAppDispatch();
	const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));
	const settings: FuseSettingsConfigType = useAppSelector(selectFuseCurrentSettings);
	const navbar = useAppSelector(selectFuseNavbar);
	const { config } = settings.layout;
	
	const isOpen = isMobile ? navbar.mobileOpen : navbar.open;
	
	const icon = isOpen ? (
		<FuseSvgIcon size={20}>heroicons-outline:x-mark</FuseSvgIcon>
	) : (
		<FuseSvgIcon size={20}>heroicons-outline:bars-3</FuseSvgIcon>
	);

	return (
		<IconButton
			className={className}
			size="small"
			sx={{
				color: isOpen ? '#ffffff' : '#000000',
				'&:hover': {
					backgroundColor: isOpen ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
				},
			}}
			onClick={() => {
				if (isMobile) {
					dispatch(navbarToggleMobile());
				} else if (config?.navbar?.style === 'style-2') {
					dispatch(
						setDefaultSettings(
							_.set({}, 'layout.config.navbar.folded', !settings?.layout?.config?.navbar?.folded)
						)
					);
				} else {
					dispatch(navbarToggle());
				}
			}}
		>
			{icon}
		</IconButton>
	);
}

export default NavbarToggleButton;
